import {
  Certificate,
  Course,
  LailaCardBlock,
  LailaMessage,
  LailaTextBlock,
  TagGroups,
  User,
} from '../../../types';

export const messageText = (message: LailaMessage) =>
  message.blocks
    .filter((block): block is LailaTextBlock => block.type === 'text')
    .map(block => block.text)
    .join('\n\n');

export const messageCards = (message: LailaMessage) =>
  message.blocks.filter((block): block is LailaCardBlock => block.type === 'card');

export const getPersonalizedMessage = (user: User) => {
  const positions = user.positions;

  if (positions?.length) {
    return 'You are a helpful assistant, who can help with finding information about a worker and about workers who are currently clocked in or clocked out.';
  }

  // Only what helps the answers: no address, date of birth or other identifiers.
  const employee = user.employee;
  let message = 'You are a helpful assistant. Here is what we know about the user you are talking to. ';

  if (employee?.job_title) {
    message += `Job title(s): ${employee?.job_title}. `;
  }

  if (user.nationality?.name) {
    message += `Nationality: ${user.nationality.name}. `;
  }

  const roles = user.worker?.tags?.filter(tag => tag.group === TagGroups.ROLE);
  if (roles?.length) {
    message += `Worked as ${roles.map(role => `${role.name} `)}. `;
  }

  const skills = user.worker?.tags?.filter(tag => tag.group === TagGroups.SKILL);
  if (skills?.length) {
    message += `Skills: ${skills.map(skill => ` ${skill.name}`)}. `;
  }

  const certificates = user.qualifications?.certificates?.items;
  if (certificates?.length) {
    message += `Certificates: ${certificates.map((item: Certificate) => ` ${item.title}`)}`;
  }

  const courses = user.qualifications?.courses?.items;
  if (courses?.length) {
    message += `Courses: ${courses.map((item: Course) => ` ${item.title}`)}`;
  }

  const tests = user.qualifications?.tests?.items;
  if (tests?.length) {
    message += `Tests: ${tests.map((item: Course) => ` ${item.title}`)}`;
  }

  return (message +=
    'Provide answers that are more consistent with these data. Remember that you will chat with this user.');
};
